import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
  tab = 0;
  items = [
    {
      routerLink: 'trips',
      title: 'Trips'
    },
    {
        routerLink: 'scores',
        title: 'Scores'
    },
    {
      routerLink: 'reports',
      title: 'Reports'
  }
  ];


  constructor() {
  }

  ngOnInit(): void {
  }

  setTab(number: number) {
    this.tab = number;
  }
}
